<template>
  <div class="m-4">
    <div class="card w-full">
      <Tabs
        :value="route.path"
        class="w-full"
      >
        <TabList class="w-full">
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
          >
            <router-link
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>

      <!-- Content slot with full width -->
      <div class="mt-4 w-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Define the tab items with icons
const items = ref([
    {
        route: '/stock/overview',
        label: 'Overview',
        icon: 'pi pi-home'  // Home icon for overview
    },
    {
        route: '/stock/items',
        label: 'Stock Items',
        icon: 'pi pi-box'  // Box icon for stock items
    },
    {
        route: '/stock/locations',
        label: 'Locations',
        icon: 'pi pi-map-marker'  // Location icon for stock locations
    },
    {
        route: '/stock/history',
        label: 'History',
        icon: 'pi pi-history'  // History icon for stock history
    }
]);
</script>

<style scoped>
/* Add any custom styling if needed */
.text-inherit {
    color: inherit;
    text-decoration: none;
}

.items-center {
    align-items: center;
}

.flex {
    display: flex;
}

.gap-2 {
    gap: 0.5rem;
}

/* Ensure card takes full width */
.card {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

/* Ensure tab content can be full width */
:deep(.p-tabview-panels) {
    width: 100%;
}

/* Apply the global tab styling */
:deep(.p-tabview .p-tabview-nav) {
    background-color: transparent !important;
    border-width: 0 !important;
}

:deep(.p-tablist-active-bar) {
    background-color: rgb(255,222,0) !important;  /* 100% yellow for the active bar */
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
    background-color: white !important;
    color: black !important;
    border: none !important;
    border-radius: 8px 8px 0 0 !important;
    margin-right: 4px !important;
}

:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
    background-color: rgb(255,249,179) !important;  /* 15% yellow for active tab */
    color: black !important;
    border: none !important;
    border-color: rgb(255,222,0) !important;  /* Override the default green with 100% yellow */
}

:deep(.p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link) {
    background-color: rgb(255,252,230) !important;  /* 10% yellow for hover */
    color: black !important;
}

:deep(.p-tabview .p-tabview-panels) {
    background-color: white !important;
    border: none !important;
    padding: 1.25rem !important;
}
</style> 